import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Container, Row, Spinner, Tab, Tabs } from "react-bootstrap";
import Slider from "react-slick";
import { FiEdit } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';

import { NewContext } from "../../Context/NewContext";
import { get_sliders_data, get_app_category_data } from "../../Controller/actions";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./preview.css";

import { CategoryBox } from "../../Components/Preview";
import BottomNav from "../../Components/Preview/BottomNav/BottomNav";

// import useSound from 'use-sound';

// import Audio1 from '../../assets/audio/Ins.mp3';
// import Audio2 from '../../assets/audio/Lofi.mp3';

const Preview = ({ title }) => {
    const [slidersData, setSlidersData] = useState([]);
    const [categoriesData, setCategoriesData] = useState([]);
    const [currentCategory, setCurrentCategory] = useState("");
    const { isLoading, setIsLoading } = useContext(NewContext);
    const navigate = useNavigate();

    const settings = {
        dots: false,
        infinite: true,
        speed: 1500,
        autoplay: false,
        autoplaySpeed: 2500,
        cssEase: "linear",
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        variableWidth: true
    };

    const getSliderData = async () => {
        setIsLoading(true);
        const getSliders = await get_sliders_data(1, "", "", { isActive: true });
        if (getSliders) {
            const { status, data, message } = getSliders;
            // console.log(data, '=======sliderData=========');
            if (status) {
                setSlidersData(data);
                setIsLoading(false);
            } else {
                toast.error(message);
            }
        }
    };

    const getCategories = async () => {
        setIsLoading(true);
        try {
            const getCategories = await get_app_category_data();
            if (getCategories) {
                const { status, data, message } = getCategories;
                if (status) {
                    // console.log(data, '----data');
                    setCategoriesData(data);
                } else {
                    // toast.error(message);
                    setCategoriesData([]);
                }
                setIsLoading(false);
            }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        getSliderData();
        getCategories();
    }, []);

    useEffect(() => {
        document.title = `Emoji Keyboard | ${title}`
    }, []);


    return (
        <Container fluid className="p-3 bg-dark vh-100">
            <Row className="align-itmes-center justify-content-center slider-row g-0">
                <Col md={6} lg={3} className="overflow-hidden bg-light p-1 rounded">
                    <Slider {...settings} className="overflow-hidden">
                        {
                            isLoading ?
                                <div className="d-flex justify-content-center align-items-center">
                                    <Spinner animation="border" />
                                </div>
                                : slidersData?.length < 1 ?
                                    <div className="d-flex justify-content-center align-items-center text-center">
                                        No Data Found
                                    </div>
                                    : slidersData?.map((_ele, i) => (
                                        <div className="slider-card-edit-btn w-100 position-relative" key={i}>
                                            <img
                                                src={_ele.preview}
                                                alt=""
                                                style={{ borderRadius: "20px" }}
                                            />
                                            <Button variant="dark" className='slider-edit-btn p-1 position-absolute' onClick={() => navigate('/sliderform', { state: _ele })}>
                                                <FiEdit size={"20px"} />
                                            </Button>
                                        </div>

                                    ))
                        }
                    </Slider>
                    {categoriesData && categoriesData.length > 1 ? (<CategoryBox categoriesData={categoriesData} />) : ""}
                    <BottomNav />
                </Col>
            </Row>
        </Container >
    );
};

Preview.defaultProps = {
    title: "Preview"
};

export default Preview;
